import SelectedOperations from './SelectedOperations';

export default SelectedOperations;
